export const validEmail = "[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}";
export const validNumber = "^[0-9]*$";
export const validPhone = "^[+/0-9]*$";

export const validFiscalCode = "^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$";
export const validFiscalCodeOrVAT = "^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$|([0-9]{11})$";

export const validPassword = "(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z])(?=.*[!@#%^&*()_=+[{]}|;:,<.>/?]).{8,}";

export const validPasswordMinimumNumberOfChar = ".{8,}";
export const validPasswordUppercaseChar = ".*[A-Z]+.*";
export const validPasswordLowercaseChar = ".*[a-z].*";
export const validNumericChar = ".*[0-9].*";
export const validPasswordSpecialChar = ".*[!@#%^&*()_=+[{]}|;:,<.>/?].*";

export const validPasswordRecoveryConfirmationCode = "[0-9]{6}";

export const validCommaNumericChar = "^[\\d{0,3},]+$"